import React from 'react';
import { useTranslation } from 'react-i18next';

const DataPolicy = () => {
  const { t } = useTranslation('newsletter');
  return (
    <a
      href="https://www.ag.ch/datenschutz"
      target="_blank"
      rel="noreferrer"
      className="datapolicy__link"
    >
      {t('data_policy_link_title')}
    </a>
  );
};

export default DataPolicy;
